export enum ELandingPageType {
  FAQ,
  OFFERS,
  PACKAGES,
  DEMO,
}
